<template>
  <div class="SubPage__container">
    <PageHeader />
    <div class="SubPage__contentGrid SubPage__firstGrid">
      <Breadcrumbs :crumbs="crumbs" />
      <div class="SubPage__header columns is-mobile">
        <div class="column">
          <h1 class="SubPage__title">Häufige Fragen</h1>
        </div>
        <SocialSharing :socialSharingLinks="socialSharingLinks" />
      </div>
    </div>
    <div class="SubPage__contentGrid">
      <FAQList :config="FAQListConfig" />
    </div>
    <Footer />
  </div>
</template>

<script>
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs.vue";
import Footer from "../Footer/Footer.vue";
import PageHeader from "../PageHeader/PageHeader.vue";
import FAQList from "../FAQList/FAQList.vue";
import SocialSharing from "../SocialSharing/SocialSharing.vue";

export default {
  name: "FAQPage",
  components: {
    Breadcrumbs,
    Footer,
    PageHeader,
    FAQList,
    SocialSharing
  },
  data() {
    return {
      crumbs: [
        {
          title: "Startseite",
          url: "#"
        },
        {
          title: "Häufige Fragen",
          url: "#"
        },
        {
          title: "Manometer",
          url: "#"
        }
      ],
      socialSharingLinks: [
        {
          url: "#",
          title: "Teilen",
          newWindow: "true",
          icon: "fab fa-facebook-f",
          color: "#3c5598"
        },
        {
          url: "#",
          title: "Teilen",
          newWindow: "true",
          icon: "fab fa-twitter",
          color: "#1da1f2"
        },
        {
          url: "#",
          title: "Teilen",
          newWindow: "true",
          icon: "fab fa-xing",
          color: "#007e7e"
        },
        {
          url: "#",
          title: "Teilen",
          newWindow: "true",
          icon: "fab fa-linkedin-in",
          color: "#0072b1"
        },
        {
          url:
            "mailto:?subject=Ihr angeforderter Link von der WIKA-Internetseite&body=Guten Tag,%0D%0A%0D%0ASie haben auf unserer Internetseite einen Link angefordert:%0D%0A%0D%0Ahttps://de-de.wika.de/products_de_de.WIKA%0D%0A%0D%0AVielen Dank für Ihr Interesse.%0D%0AIhr WIKA-Team",
          title: "Seite zusenden",
          newWindow: "true",
          icon: "fas fa-envelope",
          color: "#3480cf"
        }
      ],
      FAQListConfig: {
        searchService:
          "http://www-qa.wika.dev.intern.etecture.de/rest-services/search/category",
        resetSelectOption: "Alle",
        withExternalData: false,
        mappingUrl: "",
        loadInitialData: true,
        url:
          "http://www-qa.wika.dev.intern.etecture.de/de-de/faq_sets_json_95048.json?_c=1577959236911",
        listTitle: "FAQs",
        pagination: {
          texts: {
            page: "Seite",
            of: "von"
          },
          resultsPerPage: 12,
          resultsSelect: {
            initialSelectOption: "12 Eintr\u00e4ge pro Seite",
            selectOptions: [
              "12 Eintr\u00e4ge pro Seite",
              "24 Eintr\u00e4ge pro Seite",
              "Alle"
            ]
          }
        },
        hasSearch: true,
        filters: [
          {
            key: "measured_range",
            hasFilter: false,
            initialSelectOption: "Bitte w\u00e4hlen...",
            sort: "asc",
            label: "Messgr\u00f6\u00dfe"
          },
          {
            key: "productline",
            hasFilter: false,
            initialSelectOption: "Bitte w\u00e4hlen...",
            sort: "asc",
            label: "Produktlinie"
          },
          {
            key: "branch",
            hasFilter: false,
            initialSelectOption: "Bitte w\u00e4hlen...",
            sort: "asc",
            label: "Branche"
          },
          {
            key: "type",
            hasFilter: false,
            initialSelectOption: "Bitte w\u00e4hlen...",
            sort: "asc",
            label: "Typ"
          }
        ],
        texts: {
          productDatasheet: "Datenblatt",
          wishlist: "Merkzettel",
          resetText: "Zurücksetzen",
          searchPlaceholder: "Suchen...",
          helpText: "Bitte w\u00e4hlen Sie eine oder mehrerer Filteroptionen.",
          ebook: "Datenblatt",
          pdf: "PDF",
          validto: "G\u00fcltig bis",
          resultText: "Anzahl der gefundenen Eintr\u00e4ge:",
          productDetail: "Details"
        }
      }
    };
  }
};
</script>
